var _filter, _circle, _ellipse, _circle2, _circle3, _circle4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg09N(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "moon09n",
    cx: "40%",
    cy: "30%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#E2E8F0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#94A3B8",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rainClouds09n",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#64748B",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#475569",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "rainCloudsShadow09n"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 3,
    stdDeviation: 2,
    floodColor: "#1E293B",
    floodOpacity: 0.5
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 7,
    fill: "url(#moon09n)",
    opacity: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 40,
    rx: 20,
    ry: 12,
    fill: "url(#rainClouds09n)",
    filter: "url(#rainCloudsShadow09n)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 35,
    r: 10,
    fill: "url(#rainClouds09n)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 35,
    r: 12,
    fill: "url(#rainClouds09n)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 30,
    r: 8,
    fill: "url(#rainClouds09n)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B82F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 55,
    x2: 46,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 58,
    x2: 56,
    y2: 73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 56,
    x2: 66,
    y2: 71
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 60,
    x2: 51,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: 62,
    x2: 61,
    y2: 77
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg09N);
export default __webpack_public_path__ + "static/media/09n.3c0f697c1fc6fec2c9a9729197663095.svg";
export { ForwardRef as ReactComponent };